import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from '@doxyme/ui';
import { LocationsTable } from './components';
import './locations.scss';
import operations from '../../../../../modules/dialogs/operations';
import { CONFIRM_DIALOG } from '../../../../dialogs/constants/dialog-types';
import { OnPageLoader } from '../../../components/loading';
import { isDataLoading, locationsData } from './selectors';
import actions from './actions';
import { openLocationDialog } from './helpers';
export const Locations = () => {
    const isLoading = useSelector(isDataLoading);
    const locations = useSelector(locationsData);
    const dispatch = useDispatch();
    const intl = useIntl();
    useEffect(() => {
        dispatch(actions.fetchLocations());
    }, [dispatch]);
    const onSort = useCallback((sortingState) => {
        dispatch(actions.updateLocationsSorting(sortingState));
        dispatch(actions.fetchLocations());
    }, [dispatch]);
    const onDeleteItem = useCallback((locationId) => {
        dispatch(actions.deleteLocation({ locationId }));
    }, [dispatch]);
    const openDeleteLocationDialog = (id) => {
        operations.show(CONFIRM_DIALOG, {
            captions: {
                header: {
                    id: 'account.settings.locations.delete.dialog.header',
                    value: null,
                },
                content: {
                    id: 'account.settings.locations.delete.dialog.content',
                    value: null,
                },
                confirm: {
                    id: 'account.settings.locations.delete.dialog.confirm',
                    value: null,
                },
            },
            onConfirm: () => {
                onDeleteItem(id);
                operations.hide();
            },
            styles: {
                confirmButton: {
                    color: 'error',
                    btnStyle: 'outline',
                    size: 'medium',
                },
            },
        });
    };
    return (<div className="locations">
      {!isLoading && (<>
          <LocationsTable data={locations} onSort={onSort} onItemDelete={openDeleteLocationDialog} onItemEdit={openLocationDialog}/>
          <div className="locations__footer">
            <Button size="medium" color="primary" onClick={() => openLocationDialog()}>
              <FormattedMessage id="account.settings.locations.button.create"/>
            </Button>
          </div>
        </>)}

      {isLoading && (<div className="locations__loader">
          <OnPageLoader label={intl.formatMessage({
                id: 'account.settings.locations.loader-label',
            })}/>
        </div>)}
    </div>);
};
